import { render } from "./StepFour.vue?vue&type=template&id=6f2be068&scoped=true"
import script from "./StepFour.vue?vue&type=script&lang=js"
export * from "./StepFour.vue?vue&type=script&lang=js"

import "./StepFour.vue?vue&type=style&index=0&id=6f2be068&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f2be068"]])

export default __exports__